import { StyledModal } from '@app/components/modal/Modal';
import type { User } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import useUserActions from '@app/hooks/users/useUserActions';

export type UserDeleteModalProps = ModalProps & {
    title?: string;
    data?: User;
};

export const UserDeleteModal = ({
    title = 'Delete User?',
    data,
    ...props
}: UserDeleteModalProps) => {
    const { deleteUser } = useUserActions();

    return (
        <StyledModal
            title={title}
            mask={{ closable: false }}
            okText="Delete"
            {...props}
            confirmLoading={deleteUser?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteUser.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>Are you sure you want to remove this user?</p>
        </StyledModal>
    );
};

export default UserDeleteModal;
